import { useUrlStateManager } from 'shared/hooks/useUrlStateManager'
import { Competitors } from 'features/competitors/Competitors/ui/Competitors'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/hooks'
import { selectCurrentFilter, selectCurrentSpylaunchSettings, selectCurrentLocation, selectCurrentSpyId, selectPageState, setPageState } from 'store/applicationSlice'
import { getStateFromUrl } from 'shared/lib/getStateFromUrl'
import { useReadMonitorByIdQuery } from 'services/monitor/qmonitor'
import { jsonToParams } from 'shared/lib/jsonToParams'
import { paramsToJson } from 'shared/lib/paramsToJson'

const PageName = 'properties'

export const CompetitorsPage = (): JSX.Element => {
    return (
        <Competitors/>
    )
}